import { useIsFetching } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";

import { useLeadGeneratorAgentThread } from "../queries/useLeadGeneratorAgentThread";

export const useIsChatFetching = (): boolean => {
    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<Partial<SavedSearchRoutingParams>>();

    const { isLoading, data: threadId = "" } = useLeadGeneratorAgentThread(savedSearchId);
    const numberOfFetchingChatQueries = useIsFetching({
        queryKey: aiAgentQueryKeys.leadGenerator.chat(threadId),
    });

    return isLoading || numberOfFetchingChatQueries > 0;
};
